import React, {Component, useState} from 'react'
import * as d3 from 'd3'

import './index.css';
import HierarchicalCluster from "./HierarchicalCluster";
import { Layout } from 'antd';
import { Button } from 'antd';
import { Select } from 'antd';
import { Menu } from 'antd';
import { Dropdown} from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { Table, Radio, Divider } from 'antd';
import { Tag, Space } from 'antd'
const svgsaver=require("save-svg-as-png")

const {ShapeInfo, Intersection,Point2D,IntersectionQuery} = require("kld-intersections");


const { Option } = Select;
const { Header, Footer, Sider, Content } = Layout;



const columns = [
    {
        title: 'Group',
        dataIndex: 'name',
        render: (text) => <a>{text}</a>,
    },
    {
        title: 'Color',
        key: 'tags',
        dataIndex: 'tags',
        render: tags => (
            <>
                {tags.map(tag => {
                    let color = tag
                    return (
                        <Tag color={color} key={tag} >
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </Tag>
                    );
                })}
            </>
        ),
    }
];

var keynum = 1
var GroupDict = {}
GroupDict['Group 0'] = 1
var cur_set = 0;
var FileSaver = require('file-saver');


var svgid="#mainsvg"
const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
        cur_set = selectedRowKeys;
        //console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User',
        // Column configuration not to be checked
        name: record.name,
    }),
};
// var colorArray=['#f700ff','#0885c2','#1c8b3c','#ed334e']
var colorArray=['#e1642c','#d35d6d','#cecf7b','#4aa15f','#0885c2','#e2a2be','#ed334e','#6950a1','#1d953f','#ea66a6','#bed742','#2b4490']   //fig2
//var colorArray=['#fbf4a4','#c4da90','#a7bfd9','#f3c4d3','#f5c3a0','#a5c3af','#b9b9b4','#d2c1d5','#e7f1f5','#f9dce2','#e7f1f5','#cdcadb'] //fig3
//var colorArray=['#f16b22','#7e519f','#713e3a'] //fig1
var is_input = false;
var g;
var svg;

var BeforeWidth = 1920
var BeforeHeight = 1040
var ScreenWidth = 1920
var ScreenHeight = 1040

class IndexUI extends Component{

    constructor() {
        super();
        this.state = {
            updateview: false,
            is_input:false,
            GroupData:[{key:'0',name:'Group 0',tags:[]}],
            pointData:[],
            edges:[],
            hasLoadData:false,
            dataFile:[],
            colorArray:['#e1642c','#d35d6d','#cecf7b','#4aa15f','#0885c2','#e2a2be','#ed334e','#6950a1','#1d953f','#ea66a6','#bed742','#2b4490']
        }
        this.shape = "circle";
        this.cur_idx = 0;
        this.width = 0;
        this.height = 0;
        this.offsetY = 0;
        this.offsetX = 0;
        this.scaleX = 1;
        this.scaleY = 1;
        this.selValue = ''
        this.maxX=0
        this.maxY=0
        this.minX=0
        this.minY=0
        this.pointData = [];
        this.edges=[]
        this.lastClickIndex=-1
        this.lastClickItem=null
        this.itemBBox=[]
        this.hasCreateMST=false


        this.menu = (
            <Menu>
                <Menu.Item>
                    <a target="_blank" rel="noopener noreferrer" onClick={this.savePNG.bind(this)}>
                        PNG
                    </a>
                </Menu.Item>
                <Menu.Item>
                    <a target="_blank" rel="noopener noreferrer" onClick={this.saveSVG.bind(this)}>
                        SVG
                    </a>
                </Menu.Item>
                <Menu.Item>
                    <a target="_blank" rel="noopener noreferrer" onClick={this.saveData.bind(this)}>
                        JSON
                    </a>
                </Menu.Item>
            </Menu>
        );

    }

    init(){

        d3.select("svg").selectAll("*").remove()

        this.setState({
            updateview: false,
            is_input:false,
            GroupData:[{key:'0',name:'Group 0',tags:[]}],
            pointData:[],
            edges:[],
            hasLoadData:false,
            dataFile:[],
            colorArray:['#e1642c','#d35d6d','#cecf7b','#4aa15f','#0885c2','#e2a2be','#ed334e','#6950a1','#1d953f','#ea66a6','#bed742','#2b4490']
        })

        keynum = 1
        GroupDict = {}
        GroupDict['Group 0'] = 1
        cur_set = 0;

        svgid="#mainsvg"
        colorArray=['#e1642c','#d35d6d','#cecf7b','#4aa15f','#0885c2','#e2a2be','#ed334e','#6950a1','#1d953f','#ea66a6','#bed742','#2b4490']   //fig2

        is_input = false;

        this.shape = "circle";
        this.cur_idx = 0;
        this.width = 0;
        this.height = 0;
        this.offsetY = 0;
        this.offsetX = 0;
        this.scaleX = 1;
        this.scaleY = 1;
        this.selValue = ''
        this.maxX=0
        this.maxY=0
        this.minX=0
        this.minY=0
        this.pointData = [];
        this.edges=[]
        this.lastClickIndex=-1
        this.lastClickItem=null
        this.itemBBox=[]
        this.hasCreateMST=false


        this.menu = (
            <Menu>
                <Menu.Item>
                    <a target="_blank" rel="noopener noreferrer" onClick={this.savePNG.bind(this)}>
                        PNG
                    </a>
                </Menu.Item>
                <Menu.Item>
                    <a target="_blank" rel="noopener noreferrer" onClick={this.saveSVG.bind(this)}>
                        SVG
                    </a>
                </Menu.Item>
                <Menu.Item>
                    <a target="_blank" rel="noopener noreferrer" onClick={this.saveData.bind(this)}>
                        JSON
                    </a>
                </Menu.Item>
            </Menu>
        );

        this.child.init()


    }

    componentWillMount() {
        ScreenHeight = window.screen.availHeight
        ScreenWidth = window.screen.availWidth
    }

    componentDidMount() {

        var box=document.getElementById('mainsvg');
        this.width = box.getBoundingClientRect().width;
        this.height = box.getBoundingClientRect().height;
        //console.log([this.width,this.height])

        svg = d3.select('svg');

        g = d3.select('svg').append("g")
        svg.on('mousedown',this.handleMousedown.bind(this));

        //svg.on('mousedown',this.handleMousedown.bind(this));
        svg.call(d3.zoom()
            .extent([[0, 0], [this.width, this.height]])
            .scaleExtent([1, 8])
            .on("zoom", zoomed));

        fetch('/data/datalist.json',{
            method:'GET',
            headers:{
                'Content-Type':'application/json;charset=UTF-8'
            },
            mode:'cors',
            cache:'default'
        })
            .then(res=>res.json())
            .then(data=>{
                this.setState({
                    dataFile:data
                })
            })


        function zoomed({transform}) {
            g.attr("transform", transform);
        }

        //unable local right click menu
        document.oncontextmenu=function(){
            return false;
        }


    }

    centralizeData(){
        let minx=Number.MAX_VALUE
        let miny=Number.MAX_VALUE
        let maxx=Number.MIN_VALUE
        let maxy=Number.MIN_VALUE
        for (let i=0;i<this.pointData.length;i++){
            if (this.pointData[i].x>maxx)
                maxx=this.pointData[i].x
            if(this.pointData[i].y>maxy)
                maxy=this.pointData[i].y
            if(this.pointData[i].x<minx)
                minx=this.pointData[i].x
            if(this.pointData[i].y<miny)
                miny=this.pointData[i].y
        }

        this.maxX=maxx
        this.minX=minx
        this.maxY=maxy
        this.minY=miny

        d3.select("#mainsvg")
            .attr("viewBox",(minx-20)+" "+(miny-20)+" "+(maxx-minx+40)+" "+(maxy-miny+40))
        svg.on('mousedown',this.handleMousedown.bind(this));

        this.offsetX = minx - 20;
        this.offsetY = miny - 20;
        this.scaleX = (maxx-minx+40)/this.width;
        this.scaleY = (maxy-miny+40)/this.height;

        svg = d3.select('svg');
        svg.call(d3.zoom()
            .extent([[this.offsetX, this.offsetY], [this.scaleX, this.scaleY]])
            .scaleExtent([1, 8])
            .on("zoom", zoomed));

        function zoomed({transform}) {
            g.attr("transform", transform);
        }

        //console.log([this.offsetX,this.offsetY,this.scaleX,this.scaleY])

    }

    handleMousedown(event){
        //left click
        if(event.button === 0 && is_input){

            //console.log("IndexUI Click!")
            //console.log(g)

            //let x = event.offsetX;
            //let y = event.offsetY;
            //console.log([x,y])
            let cx = d3.pointer(event)[0]
            let cy = d3.pointer(event)[1]
            let attributes = g._groups[0][0].attributes
            if(attributes.transform != undefined){
                let val = attributes.transform.value
                let offsetX = "";
                let offsetY = "";
                let Scale = "";
                for(let j = 9; j < val.length; j ++){
                    if(val[j]=='('){
                        j++;
                        if(offsetX==""){
                            while(val[j]!=','){
                                offsetX+=val[j++];
                            }
                            j++;
                            while(val[j]!=')'){
                                offsetY+=val[j++];
                            }
                        }
                        else{
                            while(val[j]!=')'){
                                Scale+=val[j++];
                            }
                            break;
                        }
                    }
                }
                offsetX = parseFloat(offsetX)
                offsetY = parseFloat(offsetY)
                Scale = parseFloat(Scale)
                //console.log("(" + offsetX + ", " + offsetY + ", " + Scale +")")
                cx = (cx - offsetX) / Scale
                cy = (cy - offsetY) / Scale
            }


            if(this.shape === 'circle'){
                let tmpg = d3.select("#pointGroup")
                if(tmpg._groups[0][0] == null){
                    tmpg = d3.select('g')
                }
                tmpg.append('circle')
                    .attr('r', 10)
                    .attr('cx', cx)
                    .attr('cy', cy)
                    .attr('fill', colorArray[cur_set])
                    .attr('set', cur_set)
                    .attr('idx',this.cur_idx)
                    .on('mousedown',this.handleDeleteNode.bind(this));
            }
            else if(this.shape === 'rectangle'){
                let tmpg = d3.select("#pointGroup")
                if(tmpg._groups[0][0] == null){
                    tmpg = d3.select('g')
                }
                tmpg.append('rect')
                    .attr('x', cx - 5)
                    .attr('y', cy - 5)
                    .attr('width', 10)
                    .attr('height', 10)
                    .attr('fill', colorArray[cur_set])
                    .attr('set', cur_set)
                    .attr('idx',this.cur_idx)
                    .on('mousedown',this.handleDeleteNode.bind(this));
            }
            let tmp = {};
            tmp.radius = 10;
            tmp.width = 10;
            tmp.height = 10;
            tmp.x = cx;
            tmp.y = cy;
            tmp.cat = cur_set;
            tmp.id = this.cur_idx++;
            tmp.shape = this.shape

            if(this.hasCreateMST == true){
                this.child.addNewPoints(tmp)
            }
            else{
                this.pointData.push(tmp);
            }

            this.setState({pointData:this.pointData})
            console.log(this.pointData)
        }
    }


    getVecNorm(vec){
        return Math.sqrt(Math.pow(vec[0],2)+Math.pow(vec[1],2))
    }

    hasLinked(index1,index2){
        for(let i=0;i<this.edges.length;i++){
            let edge=this.edges[i]
            if(edge.start==index1&&edge.end==index2){
                return true
            }
            if(edge.start==index2&&edge.end==index1){
                return true
            }
        }
        return false
    }

    findCrossingBetweenEdgeRect(start,end,cat){
        let intersecInfo=[]
        //check the crossing of a line and rectangle

        // let cat=this.pointData[start].cat

        let startp={x:start[0],y:start[1]}
        let endp={x:end[0],y:end[1]}

        for(let i=0;i<this.itemBBox.length;i++){
            let index=parseInt(this.itemBBox[i].id)
            if(cat==this.pointData[index].cat){
                continue
            }
            const rect=ShapeInfo.rectangle({top: this.itemBBox[i].bbox.y, left: this.itemBBox[i].bbox.x, width: this.itemBBox[i].bbox.width, height: this.itemBBox[i].bbox.height})
            const line = ShapeInfo.line([startp.x, startp.y], [endp.x, endp.y]);
            const intersections = Intersection.intersect(rect, line);
            if(intersections.status=="Intersection" && intersections.points.length>1){
                // console.log([startp.x, startp.y], [endp.x, endp.y])
                // console.log({top: this.itemBBox[i].bbox.x, left: this.itemBBox[i].bbox.y, width: this.itemBBox[i].bbox.width, height: this.itemBBox[i].bbox.height})
                // console.log(intersections.points.length)
//                 for (let j=0;j<intersections.points.length;j++){
//                     let ipoint=intersections.points[j]
// /*                    d3.select(svgid)
//                         .append("circle")
//                         .attr("cx",ipoint.x)
//                         .attr("cy",ipoint.y)
//                         .attr("r",2)
//                         .attr("fill","red")
//                     console.log()*/
//
//                 }
                intersecInfo.push({
                    rect:this.itemBBox[i].bbox,
                    points:intersections.points
                })
                break
            }
        }
        return intersecInfo
    }

    checkVNodeInBound(vnode,cat){

        for(let i=0;i<this.itemBBox.length;i++){
            let index=parseInt(this.itemBBox[i].id)
            if(cat==this.pointData[index].cat){
                continue
            }
            const intersections = IntersectionQuery.pointInRectangle(  {x:vnode[0],y:vnode[1]}, {x:this.itemBBox[i].bbox.x,y:this.itemBBox[i].bbox.y},  {x:this.itemBBox[i].bbox.x+this.itemBBox[i].bbox.width,y:this.itemBBox[i].bbox.y+this.itemBBox[i].bbox.height})
            if(intersections){
                return true
            }
        }
        return false
    }

    surfaceRoutingEdge(edge){

        let startp=this.pointData[edge.start]
        let endp=this.pointData[edge.end]
        let pcat=this.pointData[edge.start].cat
        let virtrualNodes=[]
        virtrualNodes.push([startp.x,startp.y])
        virtrualNodes.push([endp.x,endp.y])
        let linesToCheck=[{
            start:[startp.x,startp.y],
            end:[endp.x,endp.y],
            ids:[0,1]
        }]

        while(linesToCheck.length>0){

            let buffer=5
            let swap=false
            let checkline=linesToCheck.pop()

            startp=checkline.start
            endp=checkline.end
            let ids=checkline.ids

            // d3.selectAll("line")
            //     .remove()
            // // .attr("stroke","black")
            // d3.select(svgid).append("line")
            //     .attr("x1",startp[0])
            //     .attr("y1",startp[1])
            //     .attr("x2",endp[0])
            //     .attr("y2",endp[1])
            //     .attr("stroke-width",2)
            //     .attr("stroke","red")

            let intersecInfo=this.findCrossingBetweenEdgeRect(startp,endp,pcat)

            if(intersecInfo.length==0){
                continue
            }
            edge.virtrual=true
            // handle crossing between edge and rect
            let points=intersecInfo[0].points
            let rec=intersecInfo[0].rect

            let line1=[[rec.x,rec.y],[rec.x+rec.width,rec.y]]
            let line3=[[rec.x,rec.y+rec.height],[rec.x+rec.width,rec.y+rec.height]]

            let line2=[[rec.x,rec.y],[rec.x,rec.y+rec.height]]
            let line4=[[rec.x+rec.width,rec.y],[rec.x+rec.width,rec.y+rec.height]]

            let point1=points[0]
            let point2=points[1]

            let vnode

            if(line1[1][1]==point1.y&&line3[1][1]==point2.y||line3[1][1]==point1.y&&line1[1][1]==point2.y||line2[0][0]==point1.x&&line4[0][0]==point2.x||line2[0][0]==point2.x&&line4[0][0]==point1.x){
                //parallel edges
                let cornerpointindex=-1
                if(line1[1][1]==point1.y&&line3[1][1]==point2.y){
                    let x1=point1.x-rec.x
                    let y1=point2.x-rec.x
                    if(x1+y1<rec.width){
                        if(x1>y1){
                            cornerpointindex=3
                        }
                        else{
                            cornerpointindex=2
                        }
                    }
                    else{
                        if(x1<y1){
                            cornerpointindex=4
                        }
                        else{
                            cornerpointindex=1
                        }
                    }
                }

                else if(line3[1][1]==point1.y&&line1[1][1]==point2.y){
                    let x1=point2.x-rec.x
                    let y1=point1.x-rec.x
                    if(x1+y1<rec.width){
                        if(x1>y1){
                            cornerpointindex=3
                        }
                        else{
                            cornerpointindex=2
                        }
                    }
                    else{
                        if(x1<y1){
                            cornerpointindex=4
                        }
                        else{
                            cornerpointindex=1
                        }
                    }
                }

                else if(line2[0][0]==point1.x&&line4[0][0]==point2.x){
                    let x1=point1.y-rec.y
                    let y1=point2.y-rec.y
                    if(x1+y1<rec.width){
                        if(x1>y1){
                            cornerpointindex=3
                        }
                        else{
                            cornerpointindex=4
                        }
                    }
                    else{
                        if(x1<y1){
                            cornerpointindex=2
                        }
                        else{
                            cornerpointindex=1
                        }
                    }
                }
                else if(line2[0][0]==point2.x&&line4[0][0]==point1.x){
                    let x1=point2.y-rec.y
                    let y1=point1.y-rec.y
                    if(x1+y1<rec.width){
                        if(x1>y1){
                            cornerpointindex=3
                        }
                        else{
                            cornerpointindex=4
                        }
                    }
                    else{
                        if(x1<y1){
                            cornerpointindex=2
                        }
                        else{
                            cornerpointindex=1
                        }
                    }
                }

                let cornerpoint=[]


                let iternum=0
                let vnode1=-1
                let vnode2=-1
                while(true) {
                    if (cornerpointindex == 1) {
                        if (!swap) {
                            cornerpoint = [rec.x, rec.y]
                        } else {
                            cornerpoint = [rec.x + rec.width, rec.y + rec.height]
                        }
                    } else if (cornerpointindex == 2) {
                        if (!swap) {
                            cornerpoint = [rec.x + rec.width, rec.y]
                        } else {
                            cornerpoint = [rec.x, rec.y + rec.height]
                        }
                    } else if (cornerpointindex == 3) {
                        if (!swap) {
                            cornerpoint = [rec.x + rec.width, rec.y + rec.height]
                        } else {
                            cornerpoint = [rec.x, rec.y]
                        }
                    } else if (cornerpointindex == 4) {
                        if (!swap) {
                            cornerpoint = [rec.x, rec.y + rec.height]
                        } else {
                            cornerpoint = [rec.x + rec.width, rec.y]
                        }
                    }

                    let centerpoint = [rec.x + rec.width / 2, rec.y + rec.height / 2]
                    let movevec = [cornerpoint[0] - centerpoint[0], cornerpoint[1] - centerpoint[1]]
                    let movenorm = this.getVecNorm(movevec)
                    movevec[0] = movevec[0] / movenorm
                    movevec[1] = movevec[1] / movenorm

                    vnode = [cornerpoint[0] + buffer * movevec[0], cornerpoint[1] + buffer * movevec[1]]

                    // d3.selectAll("line")
                    //     .remove()
                    // // .attr("stroke","black")
                    // d3.select(svgid).append("line")
                    //     .attr("x1",startp[0])
                    //     .attr("y1",startp[1])
                    //     .attr("x2",vnode[0])
                    //     .attr("y2",vnode[1])
                    //     .attr("stroke-width",2)
                    //     .attr("stroke","red")
                    //
                    // d3.select(svgid).append("line")
                    //     .attr("x1",endp[0])
                    //     .attr("y1",endp[1])
                    //     .attr("x2",vnode[0])
                    //     .attr("y2",vnode[1])
                    //     .attr("stroke-width",2)
                    //     .attr("stroke","red")

                    if(this.checkVNodeInBound(vnode,pcat)){
                        if(!swap){
                            buffer=buffer/1.5
                        }
                        swap=!swap
                        iternum+=1
                        if(iternum>10){
                            break
                        }
                    }
                    else{
                        //not in obstacle, check if this virtrual edge corssing with other edges
                        if(swap){
                            vnode1=vnode
                        }
                        else{
                            vnode2=vnode
                        }
                        swap=!swap
                        if(vnode1!=-1&&vnode2!=-1){
                            break
                        }
                        // iternum+=1
                    }

                }

                if(vnode1==-1&&vnode2==-1){
                    //fail to route the edge
                    edge.virtrual=false
                    continue
                }
                else if(vnode1!=-1&&vnode2!=-1){
                    //use the one with least crossing
                    let minCross=Number.MAX_VALUE
                    let bestVnode=null
                    let potentialNode=[vnode1,vnode2]
                    for (let n=0;n<potentialNode.length;n++){
                        let pnode=potentialNode[n]
                        let count=0
                        for(let i=0;i<this.edges.length;i++){
                            let start1=this.pointData[this.edges[i].start]
                            let end1=this.pointData[this.edges[i].end]
                            if(start1.cat!=pcat){
                                let node1={
                                    x:startp[0],
                                    y:startp[1],
                                    cat:pcat
                                }
                                let node2={
                                    x:pnode[0],
                                    y:pnode[1],
                                    cat:pcat
                                }
                                let node3={
                                    x:endp[0],
                                    y:endp[1],
                                    cat:pcat
                                }
                                if(this.checkEdgeCrossing(start1,end1,node1,node2)){
                                    count+=1
                                }
                                if(this.checkEdgeCrossing(start1,end1,node2,node3)){
                                    count+=1
                                }
                            }
                        }
                        if(count<minCross){
                            minCross=count
                            bestVnode=potentialNode[n]
                        }

                    }
                    vnode=bestVnode

                }
                else{
                    if(vnode1!=-1){
                        vnode=vnode1
                    }
                    else{
                        vnode=vnode2
                    }
                }

            }
            else{
                //neighbouring edges
                //find the corner point on the rectangle
                let temppoint=[point1.x,point2.y]
                let cornerpoint=[]
                if(temppoint[0]==rec.x&&temppoint[1]==rec.y){
                    cornerpoint=[rec.x,rec.y]
                }
                else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y){
                    cornerpoint=[rec.x+rec.width,rec.y]
                }
                else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y+rec.height){
                    cornerpoint=[rec.x+rec.width,rec.y+rec.height]
                }
                else if(temppoint[0]==rec.x&&temppoint[1]==rec.y+rec.height){
                    cornerpoint=[rec.x,rec.y+rec.height]
                }
                else{
                    temppoint=[point2.x,point1.y]
                    if(temppoint[0]==rec.x&&temppoint[1]==rec.y){
                        cornerpoint=[rec.x,rec.y]
                    }
                    else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y){
                        cornerpoint=[rec.x+rec.width,rec.y]
                    }
                    else if(temppoint[0]==rec.x+rec.width&&temppoint[1]==rec.y+rec.height){
                        cornerpoint=[rec.x+rec.width,rec.y+rec.height]
                    }
                    else if(temppoint[0]==rec.x&&temppoint[1]==rec.y+rec.height){
                        cornerpoint=[rec.x,rec.y+rec.height]
                    }
                }

                let centerpoint=[rec.x+rec.width/2,rec.y+rec.height/2]
                let movevec=[cornerpoint[0]-centerpoint[0],cornerpoint[1]-centerpoint[1]]
                let movenorm=this.getVecNorm(movevec)
                movevec[0]=movevec[0]/movenorm
                movevec[1]=movevec[1]/movenorm

                vnode=[cornerpoint[0]+buffer*movevec[0],cornerpoint[1]+buffer*movevec[1]]
            }


            // d3.selectAll("line")
            //     .remove()
            // // .attr("stroke","black")
            // d3.select(svgid).append("line")
            //     .attr("x1",startp[0])
            //     .attr("y1",startp[1])
            //     .attr("x2",vnode[0])
            //     .attr("y2",vnode[1])
            //     .attr("stroke-width",2)
            //     .attr("stroke","red")
            //
            // d3.select(svgid).append("line")
            //     .attr("x1",endp[0])
            //     .attr("y1",endp[1])
            //     .attr("x2",vnode[0])
            //     .attr("y2",vnode[1])
            //     .attr("stroke-width",2)
            //     .attr("stroke","red")


            let samepoiint=false
            for (let m=0;m<virtrualNodes.length;m++){
                if(vnode[0]==virtrualNodes[m][0]&&vnode[1]==virtrualNodes[m][1]){
                    samepoiint=true
                    break
                }
            }
            if(samepoiint){
                continue
            }

            let newid


            newid=ids[0]+1


            virtrualNodes.splice(newid,0,vnode)

            for (let n=0;n<linesToCheck.length;n++){
                if(linesToCheck[n].ids[0]>=newid){
                    linesToCheck[n].ids[0]=linesToCheck[n].ids[0]+1
                }
                if(linesToCheck[n].ids[1]>=newid){
                    linesToCheck[n].ids[1]=linesToCheck[n].ids[1]+1
                }
            }
            // virtrualNodes.push(vnode)
            linesToCheck.push({
                start:startp,
                end:vnode,
                ids:[ids[0],newid]
            })
            linesToCheck.push({
                start:vnode,
                end:endp,
                ids:[newid,ids[1]+1]
            })

            // console.log(linesToCheck)

        }

        virtrualNodes.pop()
        virtrualNodes.splice(0,1)
        edge.virtrualNodes=virtrualNodes
        return edge
    }

    deleteEdge(index){
        let deleteindex=index
        let that=this
        g
            .selectAll("line")
            .filter(function(){
                return parseInt(d3.select(this).attr("index"))==deleteindex
            })
            .remove()
        g
            .selectAll(".controlPoints")
            .filter(function(){
                return parseInt(d3.select(this).attr("edgeindex"))==deleteindex
            })
            .remove()

        g
            .selectAll(".controlPoints")
            .filter(function(){
                return parseInt(d3.select(this).attr("edgeindex"))>deleteindex
            })
            .attr("edgeindex",function(){
                return parseInt(d3.select(this).attr("edgeindex"))-1
            })

        g
            .selectAll("line")
            .filter(function(){
                return parseInt(d3.select(this).attr("index"))>deleteindex
            })
            .attr("index",function(){
                return parseInt(d3.select(this).attr("index"))-1
            })
        that.edges.splice(deleteindex,1)

        for (let i=0;i<that.edges.length;i++){
            that.edges[i].id=i
        }


    }

    drawOneEdge(index){

        this.edges[index].SVGElement=[]
        let oneEdge=this.edges[index]
        let that=this

        function handleMouseDown(event){
            if(event.button==2){
                // that.setState({
                //     hasEdit:true
                // })
                let deleteindex=parseInt(d3.select(this).attr("index"))
                let start=that.edges[deleteindex].start
                let end=that.edges[deleteindex].end
                // that.deletedEdge.push([start,end])
                that.deleteEdge(deleteindex)
                // that.optimizeMST(true)

                // for (var k in that.catPointDict){
                //     that.findCircle(k)
                // }
                // console.log(that.edges.length)
                /*                d3.select(svgid).select("#edgeGroup")
                                    .selectAll("line")
                                    .filter(function(){
                                        return parseInt(d3.select(this).attr("index"))==deleteindex
                                    })
                                    .remove()
                                d3.select(svgid).select("#edgeGroup")
                                    .selectAll(".controlPoints")
                                    .filter(function(){
                                        return parseInt(d3.select(this).attr("edgeindex"))==deleteindex
                                    })
                                    .remove()

                                d3.select(svgid)
                                    .select("#edgeGroup")
                                    .selectAll(".controlPoints")
                                    .filter(function(){
                                        return parseInt(d3.select(this).attr("edgeindex"))>deleteindex
                                    })
                                    .attr("edgeindex",function(){
                                        return parseInt(d3.select(this).attr("edgeindex"))-1
                                    })

                                d3.select(svgid)
                                    .select("#edgeGroup")
                                    .selectAll("line")
                                    .filter(function(){
                                        return parseInt(d3.select(this).attr("index"))>deleteindex
                                    })
                                    .attr("index",function(){
                                        return parseInt(d3.select(this).attr("index"))-1
                                    })
                                that.edges.splice(deleteindex,1)

                                for (let i=0;i<that.edges.length;i++){
                                    that.edges[i].id=i
                                }*/
            }
        }

        let start=oneEdge.start
        let end=oneEdge.end

        // this.nodeStartDict[start].push(i)
        // this.nodeEndDict[end].push(i)
        // this.nodeStartDict[start].push(i)
        // this.nodeEndDict[end].push(i)

        if(oneEdge.virtrual){
            let vpoints=oneEdge.virtrualNodes
            let vstart=[this.pointData[start].x,this.pointData[start].y]
            let vend
            for (let v=0;v<vpoints.length;v++){
                vend=vpoints[v]
                let newline=g
                    .append("line")
                    .attr("x1",vstart[0])
                    .attr("y1",vstart[1])
                    .attr("x2",vend[0])
                    .attr("y2",vend[1])
                    .attr("stroke-width",2)
                    .attr("stroke","black")
                    .attr("index",index)
                    .attr("isvirtrual",true)
                    .attr("segindex",v)
                    .on("mouseover",function(d,i){
                        let thisindex=d3.select(this).attr("index")
                        d3.selectAll("line")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("stroke","red")

                        console.log(that.edges[thisindex])
                    })
                    .on("mouseout",function(){
                        let thisindex=d3.select(this).attr("index")
                        d3.selectAll("line")
                            .filter(function(){
                                return d3.select(this).attr("index")==thisindex
                            })
                            .attr("stroke","black")
                            .attr("stroke-width",2)
                        console.log(that.edges[thisindex])
                    })
                    .on("mousedown",handleMouseDown)

                vstart=vend
                this.edges[index].SVGElement.push(newline)
            }
            vend=[this.pointData[end].x,this.pointData[end].y]
            let newline=g
                .append("line")
                .attr("x1",vstart[0])
                .attr("y1",vstart[1])
                .attr("x2",vend[0])
                .attr("y2",vend[1])
                .attr("stroke-width",2)
                .attr("stroke","black")
                .attr("index",index)
                .attr("isvirtrual",true)
                .attr("segindex",vpoints.length)
                .on("mouseover",function(d,i){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll("line")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("stroke","red")
                    console.log(that.edges[thisindex])
                })
                .on("mouseout",function(){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll("line")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("stroke","black")
                        .attr("stroke-width",2)
                    console.log(that.edges[thisindex])
                })
                .on("mousedown",handleMouseDown)


            this.edges[index].SVGElement.push(newline)
            // console.log()
            for (let v=0;v<vpoints.length;v++){
                    g
                    .append("circle")
                    .attr("class","controlPoints")
                    .attr("cx",vpoints[v][0])
                    .attr("cy",vpoints[v][1])
                    .attr("r",5)
                    .attr("edgeindex",index)
                    .attr("segindex",v)
                    .attr("fill","red")
                    .attr("opacity",0)
                    // .attr("display","none")
                    .on("mouseover",function(){
                        d3.select(this).attr("opacity",1)
                    })
                    .on("mouseout",function(){
                        d3.select(this).attr("opacity",0)
                    })

            }
        }
        else{
            let newline=g
                .append("line")
                .attr("x1",this.pointData[start].x)
                .attr("y1",this.pointData[start].y)
                .attr("x2",this.pointData[end].x)
                .attr("y2",this.pointData[end].y)
                .attr("stroke-width",2)
                .attr("stroke","black")
                .attr("index",index)
                .attr("isvirtrual",false)
                .on("mouseover",function(d,i){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll("line")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("stroke","red")
                    console.log(that.edges[thisindex])
                })
                .on("mouseout",function(){
                    let thisindex=d3.select(this).attr("index")
                    d3.selectAll("line")
                        .filter(function(){
                            return d3.select(this).attr("index")==thisindex
                        })
                        .attr("stroke","black")
                        .attr("stroke-width",2)
                    console.log(that.edges[thisindex])
                })
                .on("mousedown",handleMouseDown)

            this.edges[index].SVGElement.push(newline)
        }

    }

    addEdge(index1,index2,cat){
        let that=this
        let newedge={
            start:index1,
            end:index2,
            weight:-1,
            cat:cat,
            dis:-1,
            virtrual:false,
            virtrualNodes:[],
            id:this.edges.length,
            isLocalTree:false
        }
        newedge=this.surfaceRoutingEdge(newedge)
        this.edges.push(newedge)

        this.drawOneEdge(newedge.id)
    }

    handleDeleteNode(e){
        if(e.button === 2 && is_input){
                console.log(e)
                let tmp_set = parseInt(d3.select(e.path[0])._groups[0][0].attributes.set.value);
                let tmp_index = parseInt(d3.select(e.path[0])._groups[0][0].attributes.idx.value);
                d3.select(e.path[0]).remove();
                this.pointData.splice(this.pointData.findIndex(e => e.id === tmp_index), 1);
                // alert("Delete a node from set " + tmp_set);

            }

    }

    drawInit(){

        this.centralizeData();
        let data = this.pointData;

        let that=this

        function dragged(event) {
            // console.log("end!")
            let svg=d3.select("svg")
            let nodeindex=parseInt(d3.select(this).attr("idx"))
            that.pointData[nodeindex].x=event.x
            that.pointData[nodeindex].y=event.y
            if(that.shape=="circle"){
                d3.select(this)
                    .attr("cx",event.x)
                    .attr("cy",event.y)
            }
            else{
                let w=that.pointData[nodeindex].width
                let h=that.pointData[nodeindex].height
                d3.select(this)
                    .attr("x",event.x-0.5*w)
                    .attr("y",event.y-0.5*h)
            }

        }
        function dragstart() {
            // console.log("start!")
            // d3.select(this).classed("fixed", true);
            d3.select(this).attr("stroke","red")
        }

        var drag = d3.drag()
            .on("start",dragstart)
            .on("drag",dragged)
            .on("end",function(){
                d3.select(this).attr("stroke","none")
            })

        function handleMouseDown(event){

        }

        function handleDeleteNode(e){
            if(e.button === 2 && is_input){
                console.log(e)
                let tmp_set = parseInt(d3.select(e.path[0])._groups[0][0].attributes.set.value);
                let tmp_index = parseInt(d3.select(e.path[0])._groups[0][0].attributes.idx.value);
                d3.select(e.path[0]).remove();
                that.pointData.splice(that.pointData.findIndex(e => e.id === tmp_index), 1);
                // alert("Delete a node from set " + tmp_set);

            }
            else if(e.button==2 && !is_input){
                console.log("click")
                let clickIndex=parseInt(d3.select(this).attr("index"))
                if(that.lastClickIndex==-1){
                    that.lastClickIndex=clickIndex
                    that.lastClickItem=d3.select(this).attr("stroke","red")
                        .attr("stroke-width",5)
                        .attr("selected",true)
                }
                else{
                    if(clickIndex==that.lastClickIndex){
                        that.lastClickIndex=-1
                        that.lastClickItem=null
                        d3.select(this).attr("stroke","red")
                            .attr("stroke-width",1)
                            .attr("selected",false)
                    }
                    else{
                        let lastcat=that.lastClickItem.attr("category")
                        if(lastcat==d3.select(this).attr("category")){
                            if(!that.hasLinked(that.lastClickIndex,clickIndex)){
                                that.addEdge(that.lastClickIndex,clickIndex,lastcat)
                                // that.addedEdge.push([that.lastClickIndex,clickIndex])
                                //recommand an  edge to delete
                                //check circle
                                // that.findCircle(lastcat)
                            }

                            that.lastClickItem
                                .attr("stroke-width",1)
                                .attr("stroke","none")
                                .attr("selected",false)
                            that.lastClickItem=null
                            that.lastClickIndex=-1
                            // that.optimizeMST(true)
                        }
                        else{
                            that.lastClickItem
                                .attr("stroke-width",1)
                                .attr("stroke","none")
                                .attr("selected",false)
                            that.lastClickItem=d3.select(this)
                                .attr("stroke","red")
                                .attr("stroke-width",5)
                                .attr("selected",true)

                            that.lastClickIndex=clickIndex

                        }
                    }
                }

            }
        }

        var GroupCat = {}
        for(let i = 0;i < data.length;i ++){

            let curcat = -1;
            let tmpcat = data[i].cat.toString()
            let cats = tmpcat.split(",")
            if (cats.length > 1){
                for (let c = 0;c < cats.length;c ++){
                    GroupCat[parseInt(cats[c])] = 1
                    //GroupDict['Group '+ cats[c].toString()] = 1
                    curcat = Math.max(parseInt(cats[c]), curcat);
                }
            }
            else{
                GroupCat[parseInt(tmpcat)] = 1
                //GroupDict['Group '+ tmpcat.toString()] = 1
                curcat = Math.max(parseInt(tmpcat), curcat);
            }

            cur_set = Math.max(curcat,cur_set);

            if(this.shape === 'circle'){
                g.append('circle')
                    .attr("class","dataPoint")
                    .attr('r', data[i].radius)
                    .attr('cx', data[i].x)
                    .attr('cy', data[i].y)
                    .attr('fill', colorArray[curcat])
                    .attr("category",curcat)
                    .attr('set', curcat)
                    .attr("index",i)
                    .attr('idx',i)
                    .on('mousedown',handleDeleteNode)
                    .on("mouseover",function(){
                        d3.select(this)
                            .attr("stroke","red")
                    })
                    .on("mouseout",function(){
                        if(d3.select(this).attr("selected")!="true"){
                            d3.select(this).attr("stroke","none")
                        }
                    })
                    .call(drag)
            }
            else if(this.shape === 'rectangle'){
                g.append('rect')
                    .attr("class","dataPoint")
                    .attr('x', data[i].x - 0.5 * data[i].width)
                    .attr('y', data[i].y - 0.5 * data[i].height)
                    .attr('width', data[i].width)
                    .attr('height', data[i].height)
                    .attr('fill', colorArray[curcat])
                    .attr("category",curcat)
                    .attr('set', curcat)
                    .attr("index",i)
                    .attr('idx', i)
                    .on('mousedown',handleDeleteNode)
                    .on("mouseover",function(){
                        d3.select(this)
                            .attr("stroke","red")
                    })
                    .on("mouseout",function(){
                        if(d3.select(this).attr("selected")!="true"){
                            d3.select(this).attr("stroke","none")
                        }
                    })
                    .call(drag)
            }

        }

        this.itemBBox=[]

        let items=document.getElementsByClassName("dataPoint")

        // console.log(items)
        for (let i=0;i<items.length;i++){
            this.itemBBox.push({
                "id":items[i].getAttribute("index"),
                "bbox":items[i].getBBox()
            })
        }

/*        if(d3.select(svgid).select("#edgeGroup").empty()){
            d3.select(svgid)
                .insert("g","#pointGroup")
                .attr("id","edgeGroup")
        }*/

        let tmpGroupData = []
        for(let i = 0;i < this.state.GroupData.length; i ++){
            tmpGroupData.push(this.state.GroupData[i]);
        }
        keynum = 0

        GroupDict = {}
        for(var c in GroupCat){
            GroupDict['Group '+ c.toString()] = 1
        }

        for(var k in GroupDict){
            console.log(k)
            if(keynum == 0){
                tmpGroupData[0].tags = [colorArray[parseInt(keynum)]]
            }
            else{
                tmpGroupData.push({
                    key:keynum.toString(),
                    name:k,
                    tags:[colorArray[parseInt(keynum)]]
                })
            }
            keynum++;
        }

        this.setState({GroupData:tmpGroupData})

        this.cur_idx = data.length
        cur_set = keynum;

        //d3.select('svg').append('circle')
        //    .attr('r', 10)
        //    .attr('cx', 40)
        //    .attr('cy', 279)
        //    .attr('fill', colorArray[cur_set])
        //    .attr('set', cur_set)
        //    .attr('idx',this.cur_idx)
        //    .on('mousedown',this.handleDeleteNode.bind(this));
        //d3.select('svg').append('circle')
        //    .attr('r', 10)
        //    .attr('cx', 814)
        //    .attr('cy', 279)
        //    .attr('fill', colorArray[cur_set])
        //    .attr('set', cur_set)
        //    .attr('idx',this.cur_idx)
        //    .on('mousedown',this.handleDeleteNode.bind(this));

    }

    addNewSet(){
        keynum = 0
        for(var k in GroupDict){
            keynum ++;
        }
        //cur_set = keynum;
        GroupDict['Group '+ keynum.toString()] = 1
        let tmpGroupData = []
        for(let i = 0;i < this.state.GroupData.length; i ++){
            tmpGroupData.push(this.state.GroupData[i]);
        }
        tmpGroupData.push({
            key:keynum.toString(),
            name:'Group '+ keynum.toString(),
            tags:[colorArray[parseInt(keynum.toString())]]
        })
        keynum ++;
        this.setState({GroupData:tmpGroupData})
        alert("Succellfully add new set " + (keynum-1)  + " !");
    }

    scaleData(){

        let minX = Number.MAX_VALUE
        let minY = Number.MAX_VALUE
        let maxX = Number.MIN_VALUE
        let maxY = Number.MIN_VALUE
        let scale_ratio_x = 1
        let scale_ratio_y = 1
        let transform_dx = 0
        let transform_dy = 0

        if(this.pointData.length <= 0){
            return
        }

        if(this.pointData[0].shape == "rectangle"){
            for(let i = 0; i < this.pointData.length; i ++){
                let x1 = this.pointData[i].x - this.pointData[i].width / 2
                let x2 = this.pointData[i].x + this.pointData[i].width / 2
                let y1 = this.pointData[i].y - this.pointData[i].height / 2
                let y2 = this.pointData[i].y + this.pointData[i].height / 2
                minX = Math.min(minX, x1)
                minY = Math.min(minY, y1)
                maxX = Math.max(maxX, x2)
                maxY = Math.max(maxY, y2)
            }
        }
        else{
            for(let i = 0; i < this.pointData.length; i ++){
                let x1 = this.pointData[i].x - this.pointData[i].radius
                let x2 = this.pointData[i].x + this.pointData[i].radius
                let y1 = this.pointData[i].y - this.pointData[i].radius
                let y2 = this.pointData[i].y + this.pointData[i].radius
                minX = Math.min(minX, x1)
                minY = Math.min(minY, y1)
                maxX = Math.max(maxX, x2)
                maxY = Math.max(maxY, y2)
            }
        }


        let cur_width = maxX - minX
        let cur_height = maxY - minY

        // let svgwidth1 = 1200
        // let svgheight1 = 1200

        let svgwidth1 = 1500
        let svgheight1 = 1500

        //let svgwidth2 = 2000
        //let svgheight2 = 2000

        //if(cur_width > svgwidth1){
            scale_ratio_x = svgwidth1 / cur_width
        //}

        //if(cur_height > svgheight1){
            scale_ratio_y = svgheight1 / cur_height
        //}

        let ratio = Math.min(scale_ratio_x, scale_ratio_y)

        transform_dx = 0 - minX
        transform_dy = 0 - minY

        //let ddx = (svgwidth2 / 2)  - ( (minX + transform_dx) * ratio + (maxX + transform_dx) * ratio ) / 2
        //let ddy = (svgheight2 / 2) - ( (minY + transform_dy) * ratio + (maxY + transform_dy) * ratio ) / 2

        for(let i = 0; i < this.pointData.length; i ++){

            this.pointData[i].x = (this.pointData[i].x + transform_dx) * ratio
            this.pointData[i].y = (this.pointData[i].y + transform_dy) * ratio
            this.pointData[i].radius *= ratio
            this.pointData[i].width *= ratio
            this.pointData[i].height *= ratio
            //this.pointData[i].shape = "rectangle"

        }

    }

    handleUpload(){


        let filename = this.selValue

        this.init()
        this.componentWillMount()
        this.render()
        this.componentDidMount()

        if(filename == "Manhattan.txt"){
            colorArray = ['#f16b22','#7e519f','#713e3a']
        }
        else if(filename == "simpleScatterplot.json"){
            colorArray = ['#d35d6d','#0885c2','#4aa15f']
        }

        this.setState({
            colorArray:colorArray
        })

        console.log("filename:")
        console.log(filename)

        fetch('/data/'+filename,{
            method:'GET',
            headers:{
                'Content-Type':'application/json;charset=UTF-8'
            },
            mode:'cors',
            cache:'default'
        })
            .then(res=>res.json())
            .then(data=>{
                this.setState({
                    hasLoadData:true
                })
                this.pointData = data;
                //for(let i = 0; i < this.pointData.length; i ++){
                //    this.pointData[i].shape = "rectangle"
                //}
                //this.scaleData()

                for (let i=0;i<this.pointData.length;i++){
                    // this.pointData[i].width=this.pointData[i].width*1.5
                    // this.pointData[i].height=this.pointData[i].height*1.5
                    this.pointData[i].radius=10

                }
                //this.setState({
                //    upload: true
                //})

                this.setState({pointData:this.pointData})
                this.shape = data[0].shape;


                this.drawInit();
                this.setState({
                    edges:this.edges
                })
            })

    }

    changeSel(e){
        this.selValue = e;
    }

    handleInput(){
        is_input = !is_input;
        this.setState({
            is_input: is_input
        })
    }

    onRef = (ref) => {
        this.child = ref
    }

    hasCreate(){
        this.hasCreateMST = true;
    }
    saveData(){
        this.child.saveData()
    }
    savePNG(){
        svgsaver.saveSvgAsPng(document.getElementById("mainsvg"), "result.png");
    }
    saveSVG(){
        let svg=d3.select("#mainsvg")
        let width=svg.attr("width")
        let height=svg.attr("height")
        let viewbox=svg.attr("viewBox")
        let svgstr=svg.html()
        let xmlns="http://www.w3.org/2000/svg"
        svgstr="<svg xmlns=\""+xmlns+"\" width=\""+width+"\" height=\""+height+"\" viewBox=\""+viewbox+"\" >\n"+svgstr+"\n</svg>"
        let content = svgstr;
        let blob = new Blob([content], {type: "text/plain;charset=utf-8"});

        FileSaver.saveAs(blob, "result.svg");
        // console.log(svgstr)
    }

    handleManually(flag){
        is_input = flag;
        this.setState({
            is_input: is_input
        })
    }

    render(){
        let options=this.state.dataFile.map((d)=>{return <option value={d}>{d}</option> })
        // console.log("Ratio")
        // console.log(ScreenHeight/BeforeHeight)
        // console.log(ScreenWidth/BeforeWidth)
        let p1 = 20 * ScreenHeight / BeforeHeight
        let p2 = 50 * ScreenWidth / BeforeWidth
        let p3 = 20 * ScreenHeight / BeforeHeight
        let p4 = 20 * ScreenWidth / BeforeWidth
        let p5 = 25 * ScreenHeight / BeforeHeight
        let pad1 = p1.toString() + "px " + p2.toString() + "px " + p3.toString() + "px " + p4.toString() + "px"
        let pad2 = p5.toString() + "px " + p4.toString() + "px"
        return (
            <>
                <Layout>
                    <Header style={{background: 'rgb(255, 255, 255, 0.1)',textAlign: 'center', fontFamily:"Segoe UI",fontWeight:"bold",fontSize: '25px', color:"black"}}>F2-Bubbles</Header>
                    <Layout>
                        <Content theme={'light'} style={{ padding: pad1, background: 'rgb(255, 255, 255)'}}>
                            <div className="right" style={{float: "right"}}>
                                <svg id="mainsvg" width={1200 * ScreenWidth / BeforeWidth} height={750 * ScreenHeight / BeforeHeight} style={{border:"1px solid #000000"}}></svg>
                            </div>
                            <div className="left" style={{float: "left"}}>
                                <svg id="leftsvg" width={0} height={0}></svg>
                            </div>
                        </Content>
                        <Sider theme={'light'} width={600 * ScreenWidth / BeforeWidth} className="site-layout-background" style={{ padding: pad2, background: 'rgb(255, 255, 255)'}}>
                            <div className="right">
                                <Select showSearch style={{ width: 320 * ScreenWidth / BeforeWidth }} placeholder="Select an example data.." onChange={this.changeSel.bind(this)}>
                                    {options}
{/*                                    <Option value='BubbleSetExample1.txt'>example1</Option>
                                    <Option value='BubbleSetExample2.txt'>example2</Option>
                                    <Option value='BubbleSetExample3.txt'>Manually Made Data</Option>
                                    <Option value='test.txt'>test</Option>
                                    <Option value='test(1).txt'>test(1).txt</Option>
                                        <Option value='co2_gdppercapita.txt'>co2_gdppercapita.txt</Option>
                                    <Option value='life_children.txt'>life_children.txt</Option>
                                    <Option value='co2_income.txt'>co2_income.txt</Option>
                                    <Option value='life_income.txt'>life_income.txt</Option>*/}





                                </Select>
                                <Button onClick={this.handleUpload.bind(this)}>Load Example Data</Button>
                                <br/>
                                <br/>
                                <p>
                                    <Dropdown overlay={this.menu} arrow>
                                        <Button>Save As <DownOutlined /></Button>
                                    </Dropdown>
                                </p>

                                <div style={{width:"80%"}}>
                                    <Table pagination={{disabled:true, position: ['none', 'none'] }}
                                           scroll={{ y: 200 * ScreenHeight / BeforeHeight }}
                                           columns={columns}
                                           dataSource={this.state.GroupData}
                                    />
                                </div>
                                <br/>
                                <HierarchicalCluster pointData={this.state.pointData} hasLoadData={this.state.hasLoadData} isedit={this.state.is_input} edges={this.state.edges} hasCreate={this.hasCreate.bind(this)} handleManually={this.handleManually.bind(this)} onRef={this.onRef} colorArray = {this.state.colorArray}/>
                            </div>
                        </Sider>
                    </Layout>
                    <Footer style={{background: 'rgb(255, 255, 255, 0.1)', textAlign: 'center' ,fontSize: '16px'}}>F2-Bubbles ©2021</Footer>
                </Layout>
            </>
        );
    }
}

export default IndexUI;